export function teamReducer(state, action) {
  switch (action.type) {
    case "loadTeams":
      return {
        ...state,
        teams: action.teams,
      };
    case "removeTeam":
      return {
        ...state,
        teams: state.teams.filter(
          (item) => parseInt(item.id) != parseInt(action.teamId)
        ),
      };
    default:
      throw new Error();
  }
}
